export default "__VITE_ASSET__CW99O_AN__"